import {Controller} from '@stubhub/react-store-provider';

const NAMESPACE = 'header';

const controller = new Controller({
  namespace: NAMESPACE,
  mapStateToProps(state) {
    const viewportState = state.viewport || {};

    return {
      screenSize: viewportState.screenSize
    };
  },
  actionCreators: {
    showSearchBarModal
  },
  reducers: ['SUBCATNAV_CONTENT_LOADED']
});

/**
 * Callback function that Dispatches 'SEARCH_BAR_MODAL_SHOW' event to Show the Search Bar.
 *
 */
function showSearchBarModal() {
  return (dispatch) => {
    const isModalSearchActive = true;
    dispatch({type: 'SEARCH_BAR_MODAL_SHOW', isModalSearchActive});
  };
}

export default controller;
